module.exports = __webpack_public_path__ + "static/media/bg_s.5763f69b.png";